import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import AdventureManager from "../manager/AdventureManager";
// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
    'en': require('./i18n/en'), // 英文语言包
    'zh': require('./i18n/zh'), // 中文语言包
    'he': require('./i18n/he'), // 希伯来语言包
    'ar': require('./i18n/ar'), // 阿拉伯语言包
}
let lan = localStorage.getItem('zhOren') || AdventureManager.getQueryString("zhOren");
// 最后 export default，这一步肯定要写的。
export default new VueI18n({
    locale: lan, // set locale 默认显示英文
    messages,
    silentTranslationWarn: true,
})


// WEBPACK FOOTER //
// ./src/utils/i18n.js